// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Barlow+Semi+Condensed:400|Barlow:400,700&display=swap);"]);
// Module
exports.push([module.id, "* {\n  box-sizing: border-box;\n  font-family: \"Barlow Semi Condensed\", Tahoma, sans-serif;\n}\n\nbody {\n  font-size: 16px;\n}", ""]);
// Exports
module.exports = exports;
